module.exports = __webpack_public_path__ + "img/tiempo.56cf197b.png";